import styled from 'styled-components'

import { colors } from 'shared/lib'
import { t } from 'localization'
import { CardIcon } from 'shared/components/Icons'

const TP = 'checkout.panels.PaymentMethod.SavedCardPaymentOption'

type SavedCardPaymentOptionProps = {
  cardBrand: string
  cardExpMonth: number
  cardExpYear: number
  last4Digits: string
}

export const SavedCardPaymentOption = ({
  cardBrand,
  cardExpMonth,
  cardExpYear,
  last4Digits,
}: SavedCardPaymentOptionProps) => {
  return (
    <PaymentMethodDetails>
      <CardIcon brand={cardBrand} height={32} updatedIcon width={48} />
      <CardDetails>
        <CardLastFourDigits>
          <HiddenFour>••••</HiddenFour>
          {last4Digits}
        </CardLastFourDigits>
        <Expiration>
          {t(`${TP}.expiration`, {
            defaultValue: 'Exp. {month}/{year}',
            month: cardExpMonth,
            year: cardExpYear % 100,
          })}
        </Expiration>
      </CardDetails>
    </PaymentMethodDetails>
  )
}

const CardDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
`
const CardLastFourDigits = styled.div`
  color: ${colors.FC2_BLACK};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  margin-bottom: 2px;
`
const Expiration = styled.div`
  color: ${colors.FC2_GREY};
  font-weight: 400;
`
const HiddenFour = styled.span`
  font-size: 10px;
  letter-spacing: 2px;
  margin-right: 4px;
`
const PaymentMethodDetails = styled.div`
  align-items: center;
  display: flex;
  height: 36px;
`
